import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import "../styles/ProductDetails.css";
import TestimonialsCarousel from "../components/TestimonialsCarusel"
import { useProducts } from "../context/ProductsContext";
import FeaturedProducts from "../components/FeaturedProducts";
import { useCart } from "../context/CartContext";
import toast from "react-hot-toast";
import { d } from "../data/suplementsFacts";

import { useNavigate } from "react-router-dom";

export default function ProductDetail() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [selectedPack, setSelectedPack] = useState(1);
  const { products } = useProducts();
  const { addToCart } = useCart();  
  const navigate = useNavigate();
  


  useEffect(() => {
    fetch(`https://beadastra-a7epexf5c5b7dng0.canadacentral-01.azurewebsites.net/products/${id}`)
      .then((res) => res.json())
      .then((data) => setProduct(data))
      .catch((err) => console.error(err));
  }, [id]);

  // === Packs con descuentos progresivos ===
  const packs = [
    { id: 1, label: "1 PACK", multiplier: 1, discount: 0 },
    { id: 3, label: "3 PACK", multiplier: 3, discount: 0.10 },
    { id: 5, label: "5 PACK", multiplier: 5, discount: 0.15 },
  ];

  // === Datos del producto ===
  const p = product?.product;

  const selectedPackData = packs.find((pk) => pk.id === selectedPack);
  const unitPrice = p?.price || 21900;
const regularUnitPrice = unitPrice;
const discountedUnitPrice = regularUnitPrice * (1 - (selectedPackData?.discount || 0));
const regularTotal = regularUnitPrice * (selectedPackData?.multiplier || 1);
const discountedTotal = discountedUnitPrice * (selectedPackData?.multiplier || 1);

const packImages = {
  1: p?.pack1Image,
  3: p?.pack3Image,
  5: p?.pack5Image,
};


const availablePacks = packs.filter((pk) => packImages[pk.id]);

useEffect(() => {
  if (availablePacks.length === 1) {
    setSelectedPack(availablePacks[0].id);  
  }
}, [availablePacks]);

// ===== Mapper =====
const PRODUCT_KEY_MAP = {
  ashwagandha: "Ash",
  "creatina en polvo": "CreatinPowder",
  creatina: "CreatinGummy",
  vinagre: "ACV",
  colageno: "Colagen",
  colágeno: "Colagen",
  multi: "Multi",
  sleep: "Sleep",
};

// ===== Detector =====
const getProductKeyFromName = (name = "") => {
  if (!name || typeof name !== "string") return null;

  const n = name.toLowerCase();

  return Object.keys(PRODUCT_KEY_MAP).find(key =>
    n.includes(key)
  );
};

// ===== Selector =====
const productKey = getProductKeyFromName(p?.name);
const dataKey = PRODUCT_KEY_MAP[productKey];

// Evita crashes
const productData = dataKey
  ? d.find(item => item[dataKey])
  : null;

const nutritionValues = productData?.[dataKey] || [];


  return (
    <div className="product-page">
      {!product ? (
        <div className="loading">Cargando producto...</div>
      ) : (
        <>
{/* === HERO === */}
<section
  className="
    pt-[50px] relative w-full h-[90vh] flex items-center justify-center overflow-hidden hero-section
    mobile-h:items-start mobile-h:pt-[4rem] mobile-h:h-[100dvh]
  "
>
  <picture>
  <source
    media="(max-width: 1660px)"
    srcSet={p.imageHeroMobile || p.imageHero}
  />
  <img
    src={p.imageHero}
    alt={p.name}
    className="
      absolute inset-0 w-full h-full object-cover object-center
      contrast-[1.08]
    "
  />
</picture>




 <motion.div
  initial={{ opacity: 0, y: 40 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8, ease: "easeOut" }}
  className="
    relative z-10

    /* Base */
    text-left px-6 py-6
    max-w-2xl rounded-2xl

    bg-black/10 backdrop-blur-[4px]


    shadow-[0_10px_40px_rgba(0,0,0,0.45)]

    /* POSICIONAMIENTO */
    translate-x-[-40px]             /* Desktop: leve a la izquierda */

    sm:translate-x-[-20px]
    md:translate-x-[-10px]
    lg:translate-x-[-40px]

    /* Mobile: subir panel */
    mobile-h:translate-x-0
   mobile-h:translate-y-[-80px]

    mobile-h:mt-0

    mobile-h:max-w-[95%]
  "
>


  <motion.h1
  initial={{ opacity: 0, y: 25 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8, ease: "easeOut", delay: 0.1 }}
  className="
    font-black tracking-wide
    text-white
    hero-title

    drop-shadow-[0_4px_15px_rgba(0,0,0,0.85)]

    text-[clamp(1.6rem,3.8vw,3rem)]
    mobile-h:!text-[2rem]
    mobile-h:!leading-[2.2rem]
    mobile-h:tracking-wider
  "
  style={{ lineHeight: "1.25em" }}
>
  {p.name}
</motion.h1>


  <motion.p
  initial={{ opacity: 0, y: 20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.9, ease: "easeOut", delay: 0.25 }}
  className="
    mt-4
    text-white
    font-medium
    hero-subtext

    drop-shadow-[0_3px_8px_rgba(0,0,0,0.7)]

    text-[clamp(1rem,2.5vw,1.3rem)]
    mobile-h:text-[clamp(0.9rem,2.2vw,1.1rem)]
    mobile-h:max-w-[90%]
    whitespace-pre-line
  "
>
  {p.description}
</motion.p>


  {/* === Botón sin desplazamiento, fade limpio === */}
  <motion.button
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.3, ease: 'easeOut', delay: 0.1 }}
    whileHover={{ scale: 1.10 }}
    whileTap={{ scale: 0.97,  }}
    className="
      mt-6 text-white font-semibold py-3 px-8 rounded-lg shadow-lg transition hero-button
      mobile-h:py-2 mobile-h:px-5 mobile-h:text-sm
    "
    style={{
      backgroundColor: "black",
      display: "inline-block",
    }}
   onClick={() => {
      const packsSection = document.getElementById("packs");
      if (packsSection) {
        packsSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        window.getSelection()?.removeAllRanges();
        document.activeElement?.blur();
      }
    }}
  >
    Comprar ahora
  </motion.button>
</motion.div>



  {/* ✅ Flecha hacia packs */}
  <div
    className="
      absolute bottom-8 left-1/2 transform -translate-x-1/2 cursor-pointer animate-bounce z-20
      mobile-h:bottom-3
    "
    onClick={() => {
      const packsSection = document.getElementById("packs");
      if (packsSection) {
        packsSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        window.getSelection()?.removeAllRanges();
        document.activeElement?.blur();
      }
    }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-10 h-10 mobile-h:w-8 mobile-h:h-8 text-white opacity-80 hover:opacity-100 transition"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  </div>
</section>



      {/* === SECCIÓN DE PACKS === */}
      <section
        id="packs"
        className="flex flex-col items-center justify-center bg-[#f9f9f9] py-[6rem] px-[0.5rem] mobile-h:py-[4rem]"
      >
        <div className="max-w-5xl w-full bg-white rounded-2xl p-8 md:flex md:items-center md:gap-10 transition-all mobile-h:p-4">
          {/* Imagen del producto */}
          <div className="flex-1 flex justify-center mb-8 md:mb-0">
            <motion.img
              key={selectedPack}
              src={packImages[selectedPack] || p.imageHero}
              alt={`${p.name} - ${selectedPack} pack`}
              className="w-[400px] md:w-[500px] mobile-h:w-[300px] custom-img"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
            />
          </div>

          {/* Información de packs */}
          <div className="flex-1">
            <h2 className="text-2xl sm:text-3xl mobile-h:text-xl font-bold text-black mb-4 sm:mb-6 text-center md:text-left">
              Elige tu paquete ideal
            </h2>

            {/* Caja de precios */}
            <div
              className="relative rounded-xl p-4 sm:p-6 mobile-h:p-3 flex flex-col justify-center text-white transition-all"
              style={{ backgroundColor: p.color || "#000" }}
            >
              <div className="absolute top-2 right-2">
                {selectedPackData.discount > 0 ? (
                  <span className="uppercase text-xs sm:text-sm mobile-h:text-[10px] font-semibold bg-white text-black px-2 sm:px-3 py-0.5 sm:py-1 rounded-full shadow-md">
                    {selectedPackData.discount * 100}% DESCUENTO
                  </span>
                ) : (
                  <span className="uppercase text-xs sm:text-sm mobile-h:text-[10px] font-semibold bg-white text-black px-2 sm:px-3 py-0.5 sm:py-1 rounded-full shadow-md">
                    Precio Regular
                  </span>
                )}
              </div>

              <div>
                <p className="text-2xl sm:text-3xl mobile-h:text-xl font-bold">
                  ₡{discountedUnitPrice.toLocaleString()}{" "}
                  <span className="text-base sm:text-lg mobile-h:text-sm font-medium">c/u</span>
                </p>

                {selectedPackData.discount > 0 ? (
                  <p className="text-base sm:text-lg mobile-h:text-sm mt-1">
                    <span className="line-through opacity-80">
                      ₡{regularTotal.toLocaleString()}
                    </span>{" "}
                    →{" "}
                    <span className="font-semibold">
                      ₡{discountedTotal.toLocaleString()} total
                    </span>
                  </p>
                ) : (
                  <p className="text-base sm:text-lg mobile-h:text-sm mt-1 opacity-90">
                    ₡{regularTotal.toLocaleString()} total
                  </p>
                )}
              </div>
            </div>

            {/* Botones de packs */}
           <div
            className={`mt-4 sm:mt-6 gap-2 sm:gap-4 flex 
              ${availablePacks.length === 1
                ? "justify-center"      // CENTRADO si solo hay 1 pack
                : "justify-center md:justify-start"  // Comportamiento normal
              }`}
          >
            {availablePacks.map((pack) => (
              <button
                key={pack.id}
                onClick={() => setSelectedPack(pack.id)}
                style={{
                  backgroundColor:
                    selectedPack === pack.id ? p.color || "#000" : "#fff",
                  color: selectedPack === pack.id ? "#fff" : "#000",
                  borderColor: selectedPack === pack.id ? p.color || "#000" : "#ccc",
                }}
                className="px-4 sm:px-6 mobile-h:px-3 py-2 sm:py-3 mobile-h:py-1.5 rounded-full 
                          text-base sm:text-lg mobile-h:text-sm font-semibold border 
                          transition-all shadow-sm hover:scale-105"
              >
                {pack.label}
              </button>
            ))}
          </div>


           <button
            className="mt-6 sm:mt-8 w-full text-white text-base sm:text-lg font-bold py-3 rounded-full shadow-lg hover:opacity-90 transition"
            style={{ backgroundColor: p.color || "#000" }}
            onClick={() => {
              const productToAdd = {
                id: `${p.id}-${selectedPack}`,
                name: p.name,
                pack: selectedPackData.label,
                quantity: selectedPackData.quantity || 1,
                unitPrice: discountedUnitPrice,
                total: discountedTotal,
                image: packImages[selectedPack] || p.imageHero,
                color: p.color,
              };
              addToCart(productToAdd);

              // ✨ Mostrar notificación elegante
              toast.success(`${selectedPackData.label} de ${p.name} agregado al carrito`, {
                icon: "🛒",
                duration: 2500,
                style: {
                  borderRadius: "10px",
                  background: p.color,
                  color: "#fff",
                  fontWeight: "600",
                },
              });
            }}
          >
            AÑADIR AL CARRITO
          </button>
            <button
              className="mt-3 sm:mt-4 mobile-h:mt-2 w-full text-white text-base sm:text-lg mobile-h:text-sm font-bold py-3 sm:py-4 mobile-h:py-2 rounded-full shadow-lg hover:opacity-90 transition"
              style={{
                backgroundColor: "#000",
                letterSpacing: "0.5px",
              }}
              onClick={() => {
              const productToAdd = {
                id: `${p.id}-${selectedPack}`,
                name: p.name,
                pack: selectedPackData.label,
                quantity: selectedPackData.quantity || 1,
                unitPrice: discountedUnitPrice,
                total: discountedTotal,
                image: packImages[selectedPack] || p.imageHero,
                color: p.color,
              };
              addToCart(productToAdd);
              navigate("/checkout");
            }}
            >
              FINALIZAR COMPRA
            </button>
          </div>
        </div>
      </section>
      {productData && nutritionValues.length > 0 && (
      <section
        className="text-white py-10 rounded-2xl shadow-lg"
        style={{
          backgroundColor: p.color, // fondo dinámico por producto
        }}
      >
        <div className="max-w-5xl mx-auto px-6 text-center sm:text-left">

          {/* 🔹 Contenedor tipo etiqueta — Efecto premium */}
       {/* 🔹 Contenedor tipo etiqueta — Efecto premium */}
      <h2 className="text-xl sm:text-3xl font-extrabold mb-12 leading-snug text-center">
        Información Nutricional
      </h2>
        <div
          className="
            relative 
            rounded-2xl 
            mx-auto 
            overflow-hidden 
            border border-white/25 
            backdrop-blur-md
            shadow-[0_20px_40px_rgba(0,0,0,0.35)]
            transition-all duration-300
          "
          style={{
            width: "fit-content",
            minWidth: "280px",
            maxWidth: "90%",
            background:
              "linear-gradient(145deg, rgba(255,255,255,0.13), rgba(255,255,255,0.03))",
          }}
        >

          {/* Glow decorativo */}
          <div className="
            pointer-events-none
            absolute inset-0
            rounded-2xl
            bg-gradient-to-tr
            from-white/10
            via-white/5
            to-transparent
            opacity-40
          "/>

            {/* 🟣 Header de la etiqueta */}
            <div className="bg-white/20 text-white px-6 py-3 text-left font-semibold text-base sm:text-lg tracking-wide leading-tight">
              <p>
                Tamaño de porción: <span className="font-bold">2 gomitas</span>
              </p>

              <p>
                Porciones por contenedor: <span className="font-bold">30</span>
              </p>
            </div>

            {/* 🧾 Contenido nutricional */}
            <div className="px-6 py-5 border-t border-white/30">

              {/* Encabezado columnas */}
              <div className="flex justify-between text-xs uppercase tracking-wider opacity-70 pb-2 border-b border-white/30">
                <span></span>
                <div className="flex gap-6">
                  <span>Cant.</span>
                  <span>%VD*</span>
                </div>
              </div>

              {nutritionValues.map((item, i) => (
                <div
                  key={i}
                  className="flex justify-between items-center border-b border-white/20 py-2 text-sm sm:text-base"
                >
                  <span className="opacity-90 text-left">{item.name}</span>

                  <div className="flex gap-6">
                    <span className="font-semibold min-w-[45px] text-right">
                      {item.amount}
                    </span>

                    <span className="min-w-[35px] text-right opacity-90">
                      {item.dailyValue || "—"}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            {/* 💊 Uso sugerido */}
            {productData && (
              <div className="px-6 py-4 border-t border-white/20 bg-white/10">
                <p className="italic text-sm opacity-90">
                  {productData.suggestedUse}
                </p>
              </div>
            )}

            {/* 🚫 No contiene */}
            {productData && (
              <div className="px-6 py-4 border-t border-white/20 bg-white/10">
                <h3 className="font-semibold mb-2 text-white">
                  {productData.notContainTitle}
                </h3>

                <p className="text-sm leading-relaxed opacity-90">
                  {productData.notContain}
                </p>
              </div>
            )}

            {/* 📄 Declaración legal %VD */}
            <div className="px-6 pb-4 pt-2 text-[10px] opacity-70 leading-snug">
              <p>
                * Los porcentajes de Valor Diario (%VD) están basados en una dieta de 2,000 kcal.
                Sus valores diarios pueden ser mayores o menores dependiendo de sus necesidades energéticas.
              </p>
            </div>


          </div>
        </div>
      </section>  
      )}
      <div className="w-full relative bg-white" style={{
          paddingTop: "4rem", // fondo dinámico por producto
        }}>
        <h2 className="text-3xl sm:text-4xl font-extrabold mb-12 leading-snug text-center">
            Productos que te podrian interesar:          
        </h2>
      </div>      
      <FeaturedProducts products={products} />
      <TestimonialsCarousel color={p.color} />

    </>
        )}
    </div>
  );
}
